import PropTypes from 'prop-types';

import { Message, Wrapper } from './MessageCard.styled';

export function MessageCard({ children, className, isBasketVersion }) {
  return (
    <Wrapper
      isBasketVersion={isBasketVersion}
      data-testid="message-card"
      className={className}
    >
      <Message isBasketVersion={isBasketVersion}>{children}</Message>
    </Wrapper>
  );
}

MessageCard.propTypes = {
  children: PropTypes.string.isRequired,
  isBasketVersion: PropTypes.bool,
  className: PropTypes.string,
};
MessageCard.defaultProps = {
  isBasketVersion: false,
  className: undefined,
};

export default MessageCard;
